module.exports = __webpack_public_path__ + "static/media/geographic_exposure.da91fbd8.png";